import { getAttr, wxConfig } from "@/utils";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { showLoadingToast } from "vant";
import wxLogin, { hasTokenExpire } from "@/utils/wxLogin";

const houseDesc = ref({
    id: "",
    accessible: "",
    number: "",
    areaId: "",
    communityId: "",
    community: {
        schools: [],
        id: "",
        stationKey: "",
        station: null,
        name: "",
        address: "",
        areaId: "",
        adcode: "",
        location: { lon: "", lat: "" },
        builtYear: "",
        landPeriod: 0,
        buildingArea: "",
        elevator: "NO",
        volumeRatio: "",
        greeneryRatio: "",
        developer: "",
        propertyManager: "",
        propertyFee: "",
        averagePrice: "",
        totalParkingPlaces: "",
        totalUnits: "",
        totalBuildings: "",
        totalHouseholds: "",
        imageKeys: [],
        imageUrls: [],
        introduction: null,
        createdTime: "",
        schoolIds: [],
        allBuildingArea: null,
        allBuildingCount: null,
    },
    adcode: "",
    building: "",
    unit: "",
    room: "",
    purpose: "",
    floor: 0,
    totalFloors: 0,
    buildingArea: "",
    images: [],
    properties: [],
    verifyState: "",
    lastModifiedTime: "",
    createdTime: "",
    sellingPrice: "",
    sellingAveragePrice: "",
    rent: "",
    recycled: false,
    owners: [],
    favoritesTime: null,
    viewCount: null,
    favoriteCount: null,
    isFavorite: null,
});
const mark = ref(false);
/**
 * 分享
 */
const onShare = () => {
    mark.value = true;
};

/**
 * 拨打电话
 * @param {*} phone
 */
const onMakeCall = () => {
    let mobile = localStorage.getItem("mobile");
    if (mobile) {
        let oA = document.createElement("a");
        oA.href = `tel:${mobile}`;
        oA.target = "_blank";
        oA.click();
    }
};

const setShare = () => {

    const title =
        houseDesc.value.community.name +
        "-" +
        parseFloat(houseDesc.value.buildingArea) +
        "㎡-" +
        (houseDesc.value.purpose == "SALE"
            ? parseFloat(houseDesc.value.sellingPrice) + "万"
            : parseFloat(houseDesc.value.rent) + "元/月");
// 分享给朋友
// console.log('分享',houseDesc.value.community.imageUrls[0]?houseDesc.value.community.imageUrls[0]:'https://fangtuoyun.oss-cn-hangzhou.aliyuncs.com/79651e13-2a97-488f-b9ba-f8e0ee2fae87')
   console.log('分享',houseDesc.value.community.imageUrls[0])
	wx.updateAppMessageShareData({
        title: title, // 分享标题
        desc: title, // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: houseDesc.value.community.imageUrls[0], // 分享图标
        success: function () {
            // 设置成功
            console.log("Success");
        },
        fail(res) {
            console.log('errrrrr',res);
        },
    });
// 朋友圈分享
    wx.onMenuShareTimeline({
        title: title, // 分享标题
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: houseDesc.value.community.imageUrls[0], // 分享图标
        success: function () {
            // 用户点击了分享后执行的回调函数
        },
    });

    wx.onMenuShareAppMessage({
        title, // 分享标题
        desc: "ass", // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: houseDesc.value.community.imageUrls[0], // 分享图标
        success: function () {
            // 用户点击了分享后执行的回调函数
        },
    });
};

export default function (isConfig = true) {
    const isShowTagList = ref(true);
    const route = useRoute();
    const isLoading = ref(false);

    const token = localStorage.getItem("token");
// localStorage.setItem('mobile', '13867986086');
// 			localStorage.setItem('queryString', '?id=7286988776465760256&clientId=7025741580375949312&mobile=13867986086');
// 				localStorage.setItem('expire', '1737779352817');
// 					localStorage.setItem('clientId', '7025741580375949312');
// 						localStorage.setItem('token', 'eyJhbGciOiJIUzUxMiJ9.eyJleHBpcmVzIjoxNzM3Nzc5NTUyNjMwLCJ1bmlvbklkIjoiIiwiYXZhdGFyS2V5IjoibXAvYXZhdGFycy9vUXRTNDZIVlp0b0Q2TlRGTFlWcUFNb3pkU1JVIiwib3BlbklkIjoib1F0UzQ2SFZadG9ENk5URkxZVnFBTW96ZFNSVSIsIm5pY2tOYW1lIjoic29iZXIuIiwiaWF0IjoxNzM3NzcyMzUyLCJleHAiOjE3Mzc3Nzk1NTJ9.bPBbp-pccDzPMNAm0nqPR5JkebaLXdT2CdtHGCMwe5FPQPg9qK_WJVFfKUXBQvXfOj4lRqGOneDpT1DmPrcYNA');
	if (!hasTokenExpire()) {
	
        isLoading.value = true;
	
        runWxLogin();
    }
    function runWxLogin(fn) {
        wxLogin(route, () => {	
            isLoading.value = true;
            fn && fn();
            // loading.close()
            if (isConfig) {			
                wxConfig();
            }
        });
    }

    const onHandleLogin = (fn) => {
        return runWxLogin(fn);
    };

    if (route.query.clientId) {
        route.query.clientId = route.query.clientId == "undefined" ? "" : route.query.clientId;
        localStorage.setItem("clientId", route.query.clientId);
    }

    if (route.query.mobile) {
        route.query.mobile = route.query.mobile == "undefined" ? "" : route.query.mobile;
        localStorage.setItem("mobile", route.query.mobile);
    }

    return {
        runWxLogin,
        houseDesc,
        mark,
        isShowTagList,
        route,
        isLoading,
        onShare,
        onMakeCall,
        setShare,
        onHandleLogin,
    };
}
